/** A deal can be reached through a display codename ("Project Atlas") or a URL slug ("project-atlas"). */
export function dealExternalRef(codename: string): string {
  const slug = codename
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `deal:${slug}`;
}

export function canonicalDealExternalRef(externalRef: string | null | undefined): string {
  if (!externalRef) return '';
  if (!externalRef.startsWith('deal:')) return externalRef.trim();
  return dealExternalRef(externalRef.slice('deal:'.length));
}

export function sameDealExternalRef(left: string | null | undefined, right: string | null | undefined): boolean {
  return canonicalDealExternalRef(left) === canonicalDealExternalRef(right);
}
